import { Component, OnInit, OnDestroy, AfterViewInit, computed, signal, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { getActiveFestivalType, FestivalType as CoreFestivalType } from '@app/shared/components/festival-decoration/festival-decoration';

export enum FestivalType {
  NONE = 'none',
  CHRISTMAS = 'christmas',
  NEW_YEAR = 'new_year',
  EASTER = 'easter',
  HALLOWEEN = 'halloween',
  DIWALI = 'diwali',
  THANKSGIVING = 'thanksgiving'
}

@Component({
  selector: 'app-sidebar-festival-decoration',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './sidebar-festival-decoration.html',
  styleUrl: './sidebar-festival-decoration.scss'
})
export class SidebarFestivalDecoration implements OnInit, AfterViewInit, OnDestroy {
  @Input() showTree = true;
  @Input() showSanta = false;

  currentMonth = signal<number>(new Date().getMonth() + 1); // 1-12
  currentDay = signal<number>(new Date().getDate());
  isScrolled = signal<boolean>(false);
  
  festivalType = computed<FestivalType>(() => {
    const active = getActiveFestivalType(
      new Date(new Date().getFullYear(), this.currentMonth() - 1, this.currentDay())
    );
    switch (active) {
      case CoreFestivalType.CHRISTMAS:
        return FestivalType.CHRISTMAS;
      case CoreFestivalType.NEW_YEAR:
        return FestivalType.NEW_YEAR;
      case CoreFestivalType.EASTER:
        return FestivalType.EASTER;
      case CoreFestivalType.HALLOWEEN:
        return FestivalType.HALLOWEEN;
      case CoreFestivalType.THANKSGIVING:
      case CoreFestivalType.AUTUMN:
        return FestivalType.THANKSGIVING;
      default:
        return FestivalType.NONE;
    }
  });

  showFestival = computed(() => this.festivalType() !== FestivalType.NONE);
  isChristmas = computed(() => this.festivalType() === FestivalType.CHRISTMAS);

  private scrollListener?: () => void;

  ngOnInit(): void {
    // Update month periodically to handle month changes
    this.updateMonth();
    setInterval(() => this.updateMonth(), 60000); // Check every minute
  }

  ngAfterViewInit(): void {
    // Find the scrollable sidebar container with a small delay to ensure DOM is ready
    setTimeout(() => {
      this.setupScrollListener();
    }, 100);
  }

  ngOnDestroy(): void {
    if (this.scrollListener) {
      this.scrollListener();
    }
  }

  private setupScrollListener(): void {
    // Find the side_bar_wrap element (scrollable container)
    const sidebarWrap = document.querySelector('.side_bar_wrap') as HTMLElement;
    if (sidebarWrap) {
      const handleScroll = () => {
        const scrollTop = sidebarWrap.scrollTop;
        this.isScrolled.set(scrollTop > 10); // Hide santa if scrolled more than 10px
      };

      sidebarWrap.addEventListener('scroll', handleScroll, { passive: true });
      this.scrollListener = () => {
        sidebarWrap.removeEventListener('scroll', handleScroll);
      };

      // Check initial scroll position
      handleScroll();
    } else {
      // Retry if element not found (might be due to timing)
      setTimeout(() => this.setupScrollListener(), 200);
    }
  }

  private updateMonth(): void {
    const now = new Date();
    this.currentMonth.set(now.getMonth() + 1);
    this.currentDay.set(now.getDate());
  }
}

